import * as React from 'react';

import PropTypes from 'prop-types';

import {Checkbox} from 'shells/checkbox/checkbox';

import styles from './checkbox-filter.module.css';

export class CheckboxFilter extends React.Component {
    static propTypes = {
        value: PropTypes.bool,
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    render() {
        return (
            <div className={styles['checkbox-container']}>
                <Checkbox
                    label={this.props.label}
                    checked={Boolean(this.props.value)}
                    onChange={this.handleToggle}
                />
            </div>
        );
    }

    handleToggle = () => {
        const value = this.props.value ? null : {[this.props.name]: true};
        this.props.onChange(value);
    };
}
